import React, { useEffect, useRef } from "react";
import { Toast } from "bootstrap";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { Portal } from "../components/Portal";

const LoadingToasterBar = ({ progress, onClose, show }) => {
  const toastRef = useRef(null);
  return (
    <Portal layer="toast">
    <div
      className="wlj-app-toast position-fixed bottom-0 end-0 p-3"
      style={{ zIndex: 300000 }}
    >
      <div
        className="toast fade show no-border-radius mb-2"
        ref={toastRef}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        {/* <div className="toast-header text-white success-toast">
                    <strong className="me-auto">Notification</strong>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="toast"
                        aria-label="Close"
                    ></button>
                </div> */}

        <div className="toast-body toast-body-notify d-flex justify-content-between align-items-center">
           
 
            <div>
            <small className=" f-600">Video is processing... {progress}%</small>
            </div> 

            <div>

            <CloseSharpIcon
                style={{ fontSize: "18px", fontWeight: "600", color
                  : "black"
                 }}
                className="pointer"
                onClick={() => {
                  
                  onClose(); // call your callback as well
                }}
              />
            </div>
        </div>
      </div>
    </div>
    </Portal>
    //  <div className="fixed top-8 right-8 bg-white text-gray-800 rounded-lg shadow-lg border-l-4 border-blue-500 p-4 w-80 z-50 flex items-start space-x-3 animate-slide-in">
    //   <div className="mt-1">
    //     <div className="w-5 h-5 flex items-center justify-center bg-blue-100 rounded-full">
    //       <svg className="w-3 h-3 text-blue-500 animate-spin" fill="none" viewBox="0 0 24 24">
    //         <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
    //         <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
    //       </svg>
    //     </div>
    //   </div>
    //   <div className="flex-1">
    //     <strong className="block font-semibold">Processing</strong>
    //     <span className="text-sm">Video is processing... {progress}%</span>
    //   </div>
    //   <button className="text-gray-400 hover:text-gray-600" onClick={onClose}>
    //     <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/>
    //     </svg>
    //   </button>
    // </div>
  );
};

export default LoadingToasterBar;



// const LoadingToasterBar = ({ progress, onClose }) => {
//   return (
   
//   );
// };
